import * as types from '@/store/mutation-types'
import api from '@/services/api/adminHotspots'
import { handleError } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'

const getters = {
  hotspots: state => state.hotspots,
  totalHotspots: state => state.totalHotspots,
  selectedHotspot: state => state.selectedHotspot
}

const actions = {
  getHotspots({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      api
        .getHotspots(payload)
        .then(response => {
          if (response.status === 200) {

            // ADICIONA TODOS OS HOTSPOTS AO SUPER-ADMIN
            var user = localStorage.getItem('user')
            user = user ? JSON.parse(user) : {}
            user['hotspots'] = response.data.docs.map(x => x.identity)

            window.localStorage.removeItem('user')
            window.localStorage.setItem('user', JSON.stringify(user));
            // definiu novo usuário

            commit(types.HOTSPOTS, response.data.docs)
            commit(types.TOTAL_HOTSPOTS, response.data.totalDocs)
            resolve()
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },

  setHotspot({ commit }, payload) {
    commit(types.SELECTED_HOTSPOT, payload)
    window.localStorage.setItem('selectedHotspot', JSON.stringify(payload))
  },

  unsetHotspot({ commit }) {
      commit(types.SELECTED_HOTSPOT, null)
      window.localStorage.removeItem('selectedHotspot')
    }

}

const mutations = {
  [types.HOTSPOTS](state, hotspots) {
    state.hotspots = hotspots
  },
  [types.TOTAL_HOTSPOTS](state, value) {
    state.totalHotspots = value
  },
  [types.SELECTED_HOTSPOT](state, value) {
    state.selectedHotspot = value
  }
}

const state = {
  hotspots: [],
  totalHotspots: 0,
  selectedHotspot: ''
}

export default {
  state,
  getters,
  actions,
  mutations
}
